export default __webpack_public_path__ + "static/media/roboto-v20-latin-500.59a26cdb.eot";